import Pagination from '../Pagination'
import React, { useMemo } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import copy from '../../assets/icons/copy.svg'
import edit from '../../assets/icons/edit.svg'
import trash from '../../assets/icons/trashRed.svg'
import { useDispatch, useSelector } from 'react-redux';
import {deleteSiswa, getSiswa, updateSiswa, updateSiswaAccess, updateStateSiswa} from '../../features/siswaSlice';

import imgErrorValidation from '../../utils/imgErrorValidation';
import arrowDownIcon from '../../assets/icons/arrow-right.svg'
import orangImage from '../../assets/images/user-foto.png'
import AlertModal from '../AlertModal';
import { useState } from 'react';

let PageSize = 10;

function Table() {
    const { listTeachers, isLoading, urutan, currentPage } = useSelector(state => state.penilaianGuruSlice)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const [alertModalDelete, setAlertModalDelete] = useState(false)
    const [idUserToDelete, setIdUserToDelete] = useState(null)

    const currentSiswaTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;

        const sortedData = [...listTeachers].sort((a, b) => {
            if (urutan.column === "nama") {
                const namaA = String(a.nama ?? "");
                const namaB = String(b.nama ?? "");

                return urutan.order === "asc"
                    ? namaA.localeCompare(namaB)
                    : namaB.localeCompare(namaA);
            }

            if (urutan.column === "niy") {
                const niyA = Number(a.niy ?? 0);
                const niyB = Number(b.niy ?? 0);

                return urutan.order === "asc"
                    ? niyA - niyB
                    : niyB - niyA;
            }

            return 0;
        });

        return sortedData.slice(firstPageIndex, lastPageIndex);
    }, [listTeachers, urutan, currentPage]);

    function handleDetail(id) {
        navigate(`/karyawan/edit/${id}`)
    }

    function handleDelete(id) {
        dispatch(deleteSiswa(id))
            .then((res) => {
                const totalItems = listTeachers.length - 1;
                const lastItemOnPage = totalItems % PageSize === 0;
                if (lastItemOnPage && currentPage > 1) {
                    dispatch(updateStateSiswa({ name: 'currentPage', value: 1 }));
                }

                if (res.meta.requestStatus === 'fulfilled') {

                }
                dispatch(getSiswa({}))
            })
    }

    function handleCopyNiy(niy) {
        navigator.clipboard.writeText(niy)
    }

    function handleSort(column) {
        if (urutan.column === column) {
            dispatch(
                updateStateSiswa({
                    name: 'urutan',
                    value: {
                        column,
                        order: urutan.order === 'asc' ? 'desc' : 'asc'
                    }
                })
            )
        } else {
            dispatch(
                updateStateSiswa({
                    name: 'urutan',
                    value: {
                        column,
                        order: 'asc'
                    }
                })
            )
        }
    }



    return (
        <>
            <table className='table'>
                <thead>
                <tr>
                    <th className='th-niy'>
                        <div className='wrap-filter'>
                            NIY
                            <img src={arrowDownIcon} alt=""
                                 onClick={() => handleSort('niy')}
                                 className={urutan.column === 'niy' && urutan.order === 'asc' ? 'arrow-up' : 'arrow-down'}
                            />
                        </div>
                    </th>
                    <th className='th-name'>
                        <div className='wrap-filter'>
                            Nama Guru
                            <img src={arrowDownIcon} alt="" onClick={() => handleSort('nama')}
                                 className={urutan.column === 'nama' && urutan.order === 'asc' ? 'arrow-up' : 'arrow-down'}
                            />
                        </div>
                    </th>
                    <th className='th-jabatan'>Jabatan</th>
                    <th className='th-jabatan'>Tahun Evaluasi</th>
                    <th className='th-jabatan'>Sudah Mengisi</th>



                </tr>
                </thead>

                <tbody>
                {
                    isLoading ? <tr className='loading loading-table'><td>loading...</td></tr>
                        : currentSiswaTableData.length === 0 ? <tr className='loading-table'><td>Data tidak ditemukan</td></tr> :
                            currentSiswaTableData?.map((item, key) => {
                                return (
                                    <tr key={key}>
                                        <td className='niy-col'>{item?.niy}</td>
                                        <td className='row-img'>
                                            <img src={orangImage} onError={imgErrorValidation} alt="" />
                                            {item?.nama}
                                        </td>






                                        <td>{item?.jabatan}</td>
                                        <td>{item?.tahun}</td>
                                        <td style={{color:" #3661eb"}}>{item?.sudah_mengisi == true? "Sudah Mengisi" :"Belum"}</td>


                                        <td className='action-col'>
                                            <div>


                                                <div className={'title-btn'} style={{marginBottom: 0, width: '70px', fontSize: '11px', padding: '0' }}>
                                                    <Link to={
                                                        `/penilaianguru/detail/${item?.id}`
                                                    } style={{ padding: '4px 10px', fontSize: '11px', height:"30px" }}>Detail</Link>
                                                </div>


                                            </div>
                                        </td>


                                    </tr>
                                )
                            })
                }
                </tbody>
            </table>

            {!isLoading &&
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={listTeachers?.length}
                    pageSize={PageSize}
                    onPageChange={page =>
                        dispatch(updateStateSiswa({ name: 'currentPage', value: page }))
                    }
                />
            }

            {alertModalDelete && <AlertModal
                heading={'Hapus Siswa'}
                message={'Apakah anda yakin ingin menghapus siswa ini?'}
                onCancel={() => setAlertModalDelete(false)}
                onConfirm={() => handleDelete(idUserToDelete)}
            />}
        </>
    )
}

export default Table